import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';

import { PipesModule } from '@homeleite/common-components';

import { SharedModule } from '../../shared/shared.module';
import { ControllerDetailsDialogComponent } from './controller-details/controller-details-dialog/controller-details-dialog.component';
import { ControllerDetailsFormComponent } from './controller-details/controller-details-form/controller-details-form.component';
import { ControllerDetailsProducersComponent } from './controller-details/controller-details-producers/controller-details-producers.component';
import { ControllerDetailsUsersComponent } from './controller-details/controller-details-users/controller-details-users.component';
import { ControllerDetailsComponent } from './controller-details/controller-details.component';
import { ControllersComponent } from './controllers.component';
import { ControllersRoutes } from './controllers.routes';
import {
    ControllerDetailsLogsComponent
} from './controller-details/controller-details-logs/controller-details-logs.component';
import { ControllerWorkComponent } from './controller-details/controller-work/controller-work.component';

const dbConfig: DBConfig = {
    name: 'homeleite-db',
    version: 1,
    objectStoresMeta: [
        {
            store: 'controllers',
            storeConfig: { keyPath: 'id', autoIncrement: true },
            storeSchema: [
                { name: 'name', keypath: 'name', options: { unique: false } },
                { name: 'code', keypath: 'code', options: { unique: false } },
                { name: 'identificationNumber', keypath: 'identificationNumber', options: { unique: false } },
                { name: 'email', keypath: 'email', options: { unique: false } },
                { name: 'producer.id', keypath: 'producer.id', options: { unique: false } },
            ]
        }
    ]
};

@NgModule({
    declarations: [
        ControllersComponent,
        ControllerDetailsComponent,
        ControllerDetailsDialogComponent,
        ControllerDetailsFormComponent,
        ControllerDetailsProducersComponent,
        ControllerDetailsUsersComponent,
        ControllerDetailsLogsComponent,
        ControllerWorkComponent
    ],
    exports: [ControllerDetailsLogsComponent, ControllerWorkComponent],
    imports: [
        CommonModule,
        ControllersRoutes,
        NgxIndexedDBModule.forRoot(dbConfig),
        PipesModule,
        SharedModule
    ]
})
export class ControllersModule {}
